import React, {ReactNode} from 'react'
import {Tooltip} from 'react-tooltip'
import {Stack} from '@mui/material'
import {colors} from '@/constants'

interface ToolTipInterface {
  children?: ReactNode
  id: string
  position?: 'absolute' | 'fixed'
  place?: 'top' | 'right' | 'bottom' | 'left'
  background?: string
  isClick?: boolean
  openOnClick?: boolean
  styles?: {[key: string]: string}
}

const Index = ({
  children,
  id,
  styles,
  background,
  place = 'top',
  position = 'absolute',
  isClick = false,
  ...props
}: ToolTipInterface) => {
  let style = {
    padding: '20px',
    maxWidth: '260px',
  }

  if (styles) {
    style = {...style, ...styles}
  }

  return (
    <Tooltip
      {...props}
      clickable={isClick}
      positionStrategy={position}
      border={`1px solid ${colors.lightBrown}`}
      place={place}
      id={id}
      style={{
        borderRadius: '20px',
        zIndex: '3000',
        background: background ? background : colors.brown,
      }}>
      <Stack style={style}>{children}</Stack>
    </Tooltip>
  )
}

export default Index
